<template>
  <div>
    <h3>Forma de Envio</h3>
    <b-row>
      <b-col>
        <div class="ml-auto">
          <b-form-group label="" v-slot="{ ariaDescribedby }">
            <b-form-checkbox-group
              id="radio-group-1"
              v-model="oportunidade.como_submeter_envio"
              :options="options_fisico"
              :aria-describedby="ariaDescribedby"
            ></b-form-checkbox-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="isFisico">
      <b-col>
        <b-form-group label="Contato da submissão física:">
          <b-form-select v-model="oportunidade.como_submeter_contato">
            <option :value="null" disabled>
              Usar contato principal do Concedente
            </option>
            <option
              v-for="option in options_concedente_contato"
              :value="option.id"
              :key="option.id"
            >
              {{ option.nome }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="ml-auto">
          <b-form-group label="" v-slot="{ ariaDescribedby }">
            <b-form-checkbox-group
              id="radio-group-2"
              v-model="oportunidade.como_submeter_envio"
              :options="options"
              :aria-describedby="ariaDescribedby"
            ></b-form-checkbox-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="isEletronico">
      <b-col>
        <div class="ml-auto">
          <b-form-group label="Envios eletrônicos via:">
            <b-form-checkbox-group
              v-model="oportunidade.como_submeter_meio"
              :options="options_tipo"
            ></b-form-checkbox-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="isEletronicoForm && isEletronico">
      <b-col>
        <b-form-group label="Plataforma:">
          <SelectPlataforma
            v-model="oportunidade.plataforma_id"
            :disabled="!isEletronico"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="isEletronicoForm && isEletronico">
      <b-col>
        <div class="ml-auto">
          <base-input
            label="Nome:"
            :show-warning="false"
          >
            <b-form-input v-model="oportunidade.como_submeter_name" placeholder="Nome" />
          </base-input>
        </div>
      </b-col>
      <b-col>
        <div class="ml-auto">
          <base-input
            label="URL:"
            :show-warning="false"
          >
            <b-form-input
              v-model="oportunidade.como_submeter_url"
              placeholder="https://example.com"
              type="url"
            ></b-form-input>
          </base-input>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="isEletronico">
      <b-col>
        <div class="ml-auto">
          <b-form-group label="">
            <b-form-checkbox-group
              v-model="oportunidade.como_submeter_meio"
              :options="options_tipo_email"
            ></b-form-checkbox-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="isEletronico">
      <b-col v-if="isEmail">
        <div class="ml-auto">
          <base-input
            label="Email:"
            :show-warning="false"
          >
            <b-form-input
              v-model="oportunidade.como_submeter_email"
              placeholder="Email"
            ></b-form-input>
          </base-input>
        </div>
      </b-col>
    </b-row>

    <hr class="mt-0 mb-3" />
    <b-row>
      <b-col>
        <b-form-group label="Descrição de como submeter:">
          <Editor v-model="oportunidade.como_submeter_descricao" />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Editor from "@/components/Form/Editor";

import SelectPlataforma from "../SelectPlataforma.vue";
import BaseInput from "./BaseInput.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Editor, SelectPlataforma, BaseInput },
  data: () => ({
    validations: {},
    options: [
      {
        value: "eletronico",
        text: "Meio Eletrônico",
      },
    ],
    options_fisico: [
      {
        value: "fisico",
        text: "Físico",
      },
    ],
    options_tipo: [
      {
        value: "formulario_eletronico",
        text: "Formulário Eletrônico",
      },
    ],
    options_tipo_email: [
      {
        value: "email",
        text: "E-mail",
      },
    ],
    options_concedente_contato: [],
  }),

  computed: {
    ...mapState("oportunidades", ["oportunidade"]),
    isFisico() {
      return (
        this.oportunidade.como_submeter_envio.includes("fisico") ||
        this.oportunidade.como_submeter_envio.includes("ambos")
      );
    },
    isEletronico() {
      return (
        this.oportunidade.como_submeter_envio.includes("eletronico") ||
        this.oportunidade.como_submeter_envio.includes("ambos")
      );
    },
    isPlataforma() {
      return this.oportunidade.plataforma_id > 0;
    },
    isEmail() {
      return this.oportunidade.como_submeter_meio.includes("email");
    },
    isEletronicoForm() {
      return this.oportunidade.como_submeter_meio.includes(
        "formulario_eletronico"
      );
    },
  },
  methods: {
    ...mapActions("concedentes_contatos", ["ActionFind"]),

    async loadContatos() {
      this.options_concedente_contato = [];
      if (this.oportunidade.concedente_id) {
        const payload = {
          concedente_id: this.oportunidade.concedente_id,
          per_page: 50,
        };
        const { data } = await this.ActionFind(payload);
        this.options_concedente_contato = data;
      }

      const index = _.find(this.options_concedente_contato, (o) => {
        return o.id == this.oportunidade.como_submeter_contato;
      });

      if (!index) {
        this.oportunidade.como_submeter_contato = null;
      }
    },

    isValid() {
      return true;
    },
  },
  watch: {
    "oportunidade.concedente_id": {
      deep: true,
      handler: function (id, old) {
        if (old != id) {
          this.loadContatos();
        }
      },
    },
  },
  created() {
    if (!this.oportunidade.como_submeter_name) {
      this.oportunidade.como_submeter_name = "Acesse aqui";
    }
  },
};
</script>

<style lang="scss">
.input-sem-endereco {
  .custom-control-label {
    padding-right: 2em;
    font-size: 0.8em !important;

    &::before,
    &::after {
      left: inherit;
      right: 0px;
    }
  }
}
</style>
